
import { Component, Vue } from 'vue-property-decorator'
import { namespace, Action, Getter, State } from 'vuex-class'
import RelativeTime from 'library/v4/components/relative-time.vue'
import SurfaceContributors from 'vuecomponents/surface_contributors.vue'
import { n__ } from 'bits/intl'
import { transformCurrentUrl } from 'bits/location'
import uniq from 'lodash.uniq'
import type { Post, User } from 'types'
import { isRegistered } from 'bits/user_model'

@Component({
  components: {
    RelativeTime,
    SurfaceContributors,
  },
})
export default class SurfaceBuilder extends Vue {
  @Getter builder!: User
  @Getter backgroundLuminance!: 'light' | 'dark'
  @Getter colorScheme!: 'light' | 'dark'
  @Getter isMap!: boolean
  @Getter wallUpdatedAt!: string
  @Getter xMobileSurfaceLayoutV3!: boolean
  @State xContributorsList!: boolean
  @Action showContributorsList!: () => void
  @namespace('post').Getter postsArray!: Post[]

  get bgColorScheme(): 'light' | 'dark' {
    return this.isMap && !this.xMobileSurfaceLayoutV3 ? this.colorScheme : this.backgroundLuminance
  }

  get isBuilderRegistered(): boolean {
    return isRegistered(this.builder)
  }

  get builderProfileUrl(): string {
    return transformCurrentUrl({}, { path: this.builder.username })
  }

  get contributorCount(): number {
    const authorIds = this.postsArray.map((p) => p.author_id)
    const nonBuilderAuthors = authorIds.filter((id) => id !== this.builder.id)
    return uniq(nonBuilderAuthors).length
  }

  get contributorText(): string {
    return n__('%{num} contributor', '%{num} contributors', this.contributorCount, { num: this.contributorCount })
  }
}
